import { type GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import { Ear } from "api/memberPortal/ear/ear.types";
import { dataGridDateOnlyGetter } from "components/MUI/DataGrid/DataGrid.utils";

import EarLinkCell from "./cells/EarLinkCell";

const ProductsEarsColumns: GridColDef<Ear>[] = [
  {
    headerName: "EAR ID",
    field: "earid",
    renderCell: ({ row }) => <EarLinkCell row={row} />,
    flex: 1,
  },
  {
    headerName: "Submitted On",
    field: "entrydate",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
    flex: 1,
  },
  {
    headerName: "Escalated On",
    field: "release_date",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "TBD",
    flex: 1,
  },
  {
    headerName: "Completion Date",
    field: "enddate",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "TBD",
    flex: 1,
  },
  {
    headerName: "Status",
    field: "status",
    flex: 1,
  },
];

export default ProductsEarsColumns;
